import { render, staticRenderFns } from "./group-data.vue?vue&type=template&id=a1e5ef68&scoped=true&"
import script from "./group-data.vue?vue&type=script&lang=js&"
export * from "./group-data.vue?vue&type=script&lang=js&"
import style0 from "./group-data.vue?vue&type=style&index=0&id=a1e5ef68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e5ef68",
  null
  
)

export default component.exports